
angular.module('ecrd')
    .controller('RecordQueriesSummaryController', ['RecordQueriesService', function(RecordQueriesService) {
        var vm = this;

        vm.$onInit = function() {
            vm.notes = RecordQueriesService.getMetaInfo();
        };
    }]);
